import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

class SpecialFeatureB {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({overwrite: 'auto'});
    this.sections = gsap.utils.toArray('[data-element="features-special-b-section"]');
    this.currentSection = this.sections[0];

    gsap.set('[data-module="features-special-b"]', {height: (this.sections.length * 100) + 'vh'});
  }

  init() {
    this.sections.forEach((section, i) => {
      ScrollTrigger.create({
        trigger: section,
        start: () => (i - 0.5) * window.innerHeight,
        end: () => (i + 0.5) * window.innerHeight,
        onToggle: (self) => self.isActive && this.setSection(section),
        invalidateOnRefresh: true,
        onUpdate: ({isActive}) => {
          if (isActive) {
            gsap.set(section, {
              zIndex: 1,
              onComplete: () => {
                gsap.to(section,
                  {
                    autoAlpha: 1,
                  });
              },
            });
          } else {
            gsap.to(section,
              {
                autoAlpha: 0,
                onComplete: () => {
                  gsap.set(section, {zIndex: -1});
                },
              });
          }
        },
      });
    });
  }

  setSection(section) {
    if (section !== this.currentSection) {
      gsap.to(this.currentSection, {autoAlpha: 0});
      gsap.to(section, {autoAlpha: 1});
      this.currentSection = section;
    }
  }
}

const specialFeatureB = {
  init() {
    const specialFeature = document.querySelector('[data-module="features-special-b"]');

    if (specialFeature) {
      const feature = new SpecialFeatureB();
      feature.init();
    }
  },
};

export default specialFeatureB;
